<template>
  <CFooter :fixed="false">
    <div>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
      <a href="http://inventory.khaibar.id" target="_tab"> Inventory </a>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a href="#">CoreUI for Vue</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
